import { Request } from '../../../ts/ServerApi/requests/Request';

export class CheckHasUnseenUserNotificationsRequest extends Request<{}, boolean> {
  constructor() {
    //TODO call the correct APIs
    super('checkHasUnseenUserNotifications', {});
  }
}